// extracted by mini-css-extract-plugin
export default {"resizeHorizontal":"textarea-module--resize-horizontal--shYWO","resizeVertical":"textarea-module--resize-vertical--nO3qD","resizeNone":"textarea-module--resize-none--Aya3S"};